import request from '@/utils/request'
import { base } from '@/api/apiconfig'

export function login(data) {
  return request({
    // url: '/vue-admin-template/user/login',
    url: `${base}/sys/login`,
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    // url: '/vue-admin-template/user/info',
    url: `${base}/sys/userinfo`,
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: `${base}/sys/logout`,
    method: 'get'
  })
}

export function LoginByToken(data) {
  return request({
    url: `${base}/sys/loginByToken`,
    method: 'post',
    data
  })
}
